import './public-pages.scss'
import '@styles/react/libs/input-number/input-number.scss'

import wNumb from "wnumb"

import React, {
  useEffect,
  useState
} from 'react'

import Nouislider from 'nouislider-react'

import { setGAPageInfo } from '@utils'

import axios from 'axios'
import {
  Mail,
  User,
  Search,
  Lock,
  X,
  Phone
} from 'react-feather'
import {
  Button,
  Container,
  Input,
  InputGroup,
  InputGroupText,
  Label, 
  Row, Col
} from 'reactstrap'

import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
import defaultAvatar from '@src/assets/images/logo/fys-avatar-blank.png'
import CheckoutForm from './CheckoutForm'
import Footer from './Footer'
import NavBar from './NavBar'
import { useParams, useNavigate } from 'react-router-dom'
import Avatar from "@components/avatar"
import toast from 'react-hot-toast'
import { useForm, Controller } from "react-hook-form"

import '@styles/react/libs/noui-slider/noui-slider.scss'
import FortHoodHorse from '../components/donationPickers/forthood'

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_TEST_PUBLIC_KEY)
const DonationForm = () => {
  const [isContinue, setIsContinue] = useState(false)
  const [customDonation, setCustomDonation] = useState(false)
  const [donationAmount, setDonationAmount] = useState(50)
  const [donationCardId, setDonationCardId] = useState('')
  const [donationCardConfig, setDonationCardConfig] = useState(null)
  const [donationCardSpaces, setDonationCardSpaces] = useState({})
  const [donationLevels, setDonationLevels] = useState([20, 50, 75, 100, 200])
  const [transactionFee] = useState(false)
  const [tipAmount, setTipAmount] = useState(15)
  const [coverFeeAmount, setCoverFeeAmount] = useState(0)
  //const [donationCheckbox, setDonationCheckbox] = useState(false)
  const [formValues, setFormValues] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
    showAnnonymous: false

  })
  const { control, handleSubmit, formState: { errors } } = useForm()

  const ToastError = ({ t }) => {
    return (
      <div className='d-flex'>
        <div className='me-1'>
          <Avatar size='sm' color='danger' icon={<Lock size={12} />} />
        </div>
        <div className='d-flex flex-column'>
          <div className='d-flex justify-content-between'>
            <h6></h6>
            <X size={12} className='cursor-pointer' onClick={() => toast.dismiss(t?.id)} />
          </div>
          <span>Your submission failed. Please check your form fields and try again.</span>
        </div>
      </div>
    )
  }

  // eslint-disable-next-line no-unused-vars
  const { fundraiser_slug, campaign_slug, division_slug } = useParams()
  const navigate = useNavigate()

  const campaign_slug_query = new URLSearchParams(window.location.search).get(
    "campaign_slug"
  )
  const organization_slug_query = new URLSearchParams(window.location.search).get(
    "organization_slug"
  )

  const [campaign, setCampaign] = useState()
  const [fundraiser, setFundraiser] = useState()
  const [organization, setOrganization] = useState()

  const changeFees = (newFeeAmount) => {
    setTipAmount(newFeeAmount[0])
  }

  async function getCampaign() {
    const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/campaign/${campaign_slug || campaign_slug_query}/public`)
    if (res.data.hasError) {
      navigate('/misc/error')
    } else {
      setTipAmount(parseInt(res.data.data.feeRecoveryDefault))
      if (res.data.data.donationLevels) {
        setDonationLevels(JSON.parse(res.data.data.donationLevels))
        setDonationAmount(JSON.parse(res.data.data.donationLevels)[2])
      }
      setCampaign(res.data.data)
    }

  }
  useEffect(() => {
    if (campaign) {
      document.title = `FundYouthSports - ${campaign.title} Campaign Home - Donate`
      setGAPageInfo(document.title)
      if (process.env.REACT_APP_DEV_ENV === "production") {
          window.gtag('event', 'Donation View', {
            campaign_id: campaign.id
          })

          const activityData = {
            entityType: 'Campaign',
            entityId: campaign.id,
            actionCode: "publicview",
            message: "donation view",
            source: "Campaign",
            sourceId: campaign.id
        }
        axios.post(`${process.env.REACT_APP_BASE_URL}/api/v1/activity`, activityData)
      }
    }
  }, [campaign])
  async function getFundraiser() {
    const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/fundraiser/donate?url_slug=${fundraiser_slug}&ip_address=127.0.0.1`)
    if (res.data.hasError) {
      navigate('/misc/error')
    } else {
      if (res.data.data.donationTotals.currentCard) {
        setDonationCardId(res.data.data.donationTotals.currentCard.cardId)
        setDonationCardConfig(res.data.data.donationTotals.currentCard.cardConfig)
      }
      if (res.data.data.campaign.donationForm === "9") setDonationAmount(0)
      setFundraiser(res.data.data)
    }
  }
  async function getOrganization() {
    const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/api/v1/divisions/${division_slug}/campaign/${campaign_slug || campaign_slug_query}`)
    if (res.data.hasError) {
      if ((!division_slug || division_slug === 'undefined') && (campaign_slug || campaign_slug_query)) {
        navigate(`/campaigns/${campaign_slug || campaign_slug_query}`)
      } else {
        navigate(`/misc/error`)
      }
    } else {
      setOrganization(res.data.data)
    }
  }
  useEffect(() => {
    if (organization) {
      document.title = `FundYouthSports - ${organization.organization.name} - ${organization.campaign.title} Campaign Home - Donate`
      
      if (process.env.REACT_APP_DEV_ENV === "production") {
        window.gtag('event', 'Donation View', {
          division_id: organization.organization.id,
          campaign_id: organization.campaign.id
        })

        const activityData = {
            entityType: 'Campaign',
            entityId: organization.campaign.id,
            actionCode: "publicview",
            message: "donation view",
            source: "Organization",
            sourceId: organization.id
        }
        axios.post(`${process.env.REACT_APP_BASE_URL}/api/v1/activity`, activityData)
      }
    }
  }, [organization])
  useEffect(() => {
    if (fundraiser) {
      document.title = `FundYouthSports - ${fundraiser.firstName} ${fundraiser.lastName} - Donate`
      if (process.env.REACT_APP_DEV_ENV === "production") {
        window.gtag('event', 'Donation View', {
          player_id: fundraiser.id,
          campaign_id: fundraiser.campaign.id,
          division_id: (fundraiser.organization) ? fundraiser.organization.id : null
        })
        
        const activityData = {
            entityType: 'Campaign',
            entityId: fundraiser.campaign.id,
            actionCode: "publicview",
            message: "donation view",
            source: "Fundraiser",
            sourceId: fundraiser.id
        }
        axios.post(`${process.env.REACT_APP_BASE_URL}/api/v1/activity`, activityData)
      }
    }
  }, [fundraiser])
  useEffect(() => {
    if (campaign_slug) {
      getCampaign()
    }
  }, [campaign_slug])
  useEffect(() => {
    if (fundraiser_slug) {
      getFundraiser()
    }
  }, [fundraiser_slug])
  useEffect(() => {
    if (division_slug) {
      getOrganization()
    }
  }, [division_slug])

  const [clientSecret, setClientSecret] = useState("")
  //donation
  const [donation, setDonation] = useState("")

  useEffect(() => {

    if (clientSecret) {
      setIsContinue(!isContinue)
    }

  }, [clientSecret])

  const currFormat = wNumb({ decimals: 2, prefix: "$ "})

  useEffect(() => {
    setCoverFeeAmount(parseInt(donationAmount) + (parseInt(donationAmount) * ((parseInt(tipAmount) / 100))))
  }, [donationAmount, tipAmount])
  
  const updateClientSecret = (value) => {
    setClientSecret(value)
  }
  function paymentIntent() {
    axios.post(`${process.env.REACT_APP_BASE_URL}/api/v1/stripe/pi`, {
      user: '',
      firstName: formValues.firstName,
      lastName: formValues.lastName,
      email: formValues.email,
      phone: formValues.phone,
      cardAmount: donationAmount * 100,
      campaign: campaign_slug || campaign_slug_query,
      organization: division_slug || organization_slug_query,
      fundraiser: fundraiser_slug,
      coverFees: (transactionFee) ? 1 : 0,
      showAnnonymous: (formValues.showAnnonymous) ? 1 : 0,
      message: formValues.message,
      platformFeePct: tipAmount,
      cardId: donationCardId,
      cardSpaces: JSON.stringify(donationCardSpaces)
    })
      .then((data) => {
        setClientSecret(data.data.data.paymentIntent.client_secret)
        setDonation(data.data.data.donation)

        if (process.env.REACT_APP_DEV_ENV === "production") {
          const activityData = {
              entityType: 'Campaign',
              actionCode: "publicview",
              message: "donation payment"
          }
          if (fundraiser) {
            activityData.entityId = fundraiser.campaign.id
            activityData.source = "Fundraiser"
            activityData.sourceId = fundraiser.id
          } else if (organization) {
            activityData.entityId = organization.campaign.id
            activityData.source = "Organization"
            activityData.sourceId = organization.id
          } else if (campaign) {
            activityData.entityId = campaign.id
            activityData.source = "Campaign"
            activityData.sourceId = campaign.id
          }
          axios.post(`${process.env.REACT_APP_BASE_URL}/api/v1/activity`, activityData)
        }

      })
      .catch(error => {
        console.log("error....error")
        console.log(error)
        toast(t => (
          <ToastError t={t} />
        ))
      })
  }
  const onSubmit = data => {
    formValues.firstName = data.firstName
    formValues.lastName = data.lastName
    formValues.email = data.email
    formValues.phone = data.phone
    formValues.message = data.message
    formValues.showAnnonymous = data.showAnnonymous

    paymentIntent()
  }
  const appearance = {
    theme: 'stripe'
  }

  const changeDonationAmount = (e) => {
    const ammount = parseInt(e.target.innerHTML.split('$')[1])
    setDonationAmount(ammount)
    setCustomDonation(false)
  }

  const addCustomDonationAmount = (e) => {
    const ammount = e.target.value
    setDonationAmount(ammount)
  }

  const ChangeFormValues = (e) => {
    const key = e.target.name
    const val = e.target.value
    setFormValues(preVal => {
      return {
        ...preVal,
        [key]: val
      }
    })
  }

  const renderDonationlevels = () => {
    if (donationLevels) {
      return [...donationLevels].map((x, i) => <div key={`donationLevel-${i}`} className="col-4 myFlex" style={{ padding: ".5rem" }}>
      <Button.Ripple color={(!customDonation && donationAmount === parseInt(x)) ? "danger" : "light"} size='sm' className="myCenter donation_btn" onClick={changeDonationAmount}>${x}</Button.Ripple>
    </div>)
    }
  }

  const options = {
    clientSecret,
    appearance
  }

  return (
    <div>
      <NavBar></NavBar>
      <div id='donationform'>
        <div className='myComponent' style={{ background: "#f0f0f0" }}>
          {(division_slug && organization) && (
            <Container fluid="md" className='container'>
              <Row>
                <Col md="3" xs="3" className=''>
                  <img src={organization?.organization?.logo || defaultAvatar} style={{ maxWidth: "100%" }}></img>
                </Col>
                <Col md="9" xs="9" className=''>
                  <p className='mb-25'>THANK YOU FOR SUPPORTING</p>
                  <h2 className='mt-0 mb-2'>{organization?.campaign?.title}</h2>
                  <p className='text-small mb-25'>Your donation directly supports</p>
                  <h5 className='mb-2'>{organization?.organization?.name}</h5>
                  <p className='d-none d-md-block' style={{ whiteSpace: "pre-line" }}>{organization?.campaign?.shortDescription}</p>
                </Col>
              </Row>
            </Container>
          )}
          {(campaign_slug && campaign) && (<Container fluid="md" className='container'>
            <Row>
              <Col xs="3">
                <img src={campaign?.logoImage || defaultAvatar} style={{ maxWidth: "100%" }}></img>
              </Col>
              <Col xs="9">
                <p className='mb-25'>THANK YOU FOR SUPPORTING</p>
                <h2 className='mt-0 mb-2'>{campaign?.title}</h2>
                <p className='text-small mb-25'>Your donation directly supports</p>
                <h5 className='mb-2'>{campaign?.organization?.name}</h5>
                <p className='d-none d-md-block' style={{ whiteSpace: "pre-line" }}>{campaign?.shortDescription}</p>
              </Col>
            </Row>
          </Container>)}
          {(fundraiser_slug && fundraiser) && (<Container fluid="md" className='container'>
            <Row>
              <Col xs="3">
                <img src={fundraiser?.avatar} style={{ maxWidth: "100%", maxHeight: "250px" }}></img>
              </Col>
              <Col xs="9">
                <p className='mb-25'>THANK YOU FOR SUPPORTING</p>
                <h2 className='mt-0 mb-2'>{fundraiser?.firstName} {fundraiser?.lastName}</h2>
                <p className='text-small mb-25'>Your donation directly supports</p>
                <h5 className='mb-2'>{fundraiser?.firstName} and the {fundraiser?.organization?.name}</h5>
                <p className='d-none d-md-block' style={{ whiteSpace: "pre-line" }}>{(fundraiser?.donationTotals?.fundraisingReason && fundraiser?.donationTotals?.fundraisingReason !== "") ? fundraiser?.donationTotals?.fundraisingReason : fundraiser?.fundraisingReason}</p>
              </Col>
            </Row>
          </Container>)}
        </div>
        <div className='myComponent' style={{ background: "white" }}>

          {!isContinue && (<Container fluid="md" className='container'>
            <div className="myFlex mb-1 mb-md-2">
              <h1 className='myCenter' style={{ color: "black", fontWeight: "bold" }}>Choose Your Donation Amount</h1>
            </div>
            <div className='row' style={{ paddingBottom: "2rem" }}>
              <div className="col-md-3"></div>
              <div className="col-md-6">
                <div className="row">
                    {donationCardId !== "" && (<FortHoodHorse donationCardConfig={donationCardConfig} setDonationCardConfig={setDonationCardConfig} setDonationCardSpaces={setDonationCardSpaces} setDonationAmount={setDonationAmount} />)}
                    <div className='col-md-12 d-flex flex-row' style={{ padding: "1rem" }}>
                      <span className='display-5 me-1'>$</span>
                      <Input type='text' id='readonlyInput' readOnly={(donationCardId !== "")} value={`${donationAmount}`} style={{ textAlign: "center", height: "4rem", fontSize: "2rem" }} onChange={addCustomDonationAmount} />
                    </div>
                    {donationCardId === "" && (<div className='col-md-12'>
                      <div className='row'>
                        {renderDonationlevels()}
                        <div className="col-4 myFlex" style={{ padding: ".5rem" }}>
                          <Button.Ripple color={(customDonation) ? "danger" : "light"} size='sm' className="myCenter donation_btn" onClick={() => { setCustomDonation(true) }}>CUSTOM</Button.Ripple>
                        </div>
                      </div>
                    </div>)}
                </div>
                <div className='row mt-2' style={{ paddingBottom: "3rem" }}>
                  
                  <div className='col-md-12 text-center text-md-left'>
                    <strong>Make your contribution go further!</strong>
                    <p>Please consider covering the platform and transaction fees associated with this donation. This ensures your fundraiser receives the maximum donation amount.</p>
                  </div>
                  <div className="col-md-12 mt-2" style={{ textAlign: "center" }}>
                    <Nouislider
                      step={5}
                      start={tipAmount}
                      tooltips={wNumb({decimals: 0, suffix: '%'})}
                      className='mt-1 mb-3'
                      range={{
                        min: 0,
                        max: 30
                      }}
                      pips={{
                        mode: 'steps',
                        stepped: true,
                        density: 15,
                        format: wNumb({
                          decimals: 0,
                          suffix: '%'
                        })
                      }}
                      onChange={(evt) => { changeFees(evt) }}
                    />
                    <br />
                    <p className='mb-25 mb-1 border rounded p-1 border-danger' hidden={tipAmount > 0}>Covering platform fees helps to continuously improve our platform for donors like you and the fundraisers you are supporting. The first 15% of your support goes directly to the fundraiser.</p>
                    <strong style={{ fontSize: "22px" }}>Your Total Due Today: {currFormat.to(coverFeeAmount)}</strong>
                  </div>
                </div>
              </div>
              <div className="col-md-3"></div>
            </div>
            {/* <div className='row' style={{ paddingBottom: "3rem" }}>
              <div className='col-md-2'></div>
              <div className="col-md-8" style={{ textAlign: "center" }}>
                <div className='form-check form-check-primary'>
                  <Input type='checkbox' id='checkbox' checked={transactionFee} style={{ border: "1px solid #000000" }} onChange={() => { setTransactionFee(!transactionFee) }} />
                  <Label className='form-check-label label' for='checkbox' >
                    I'd like to make my donation go further and cover the transaction fees associated with this donation. <br /><span style={{ fontWeight: "normal", fontSize: ".9rem" }}>(2.9% + $0.30 per transaction as charged by our credit card processor)</span>
                  </Label>
                </div>
              </div>
              <div className='col-md-2'></div>
            </div> */}
            
            <div style={{ borderBottom: "solid 1px rgb(200, 200, 200)", marginBottom: "4rem" }}></div>
            
            <div className='row'>
              <div className='col-md-2'></div>
              <div className='col-md-8'>
                <div className="myFlex" style={{ paddingBottom: "2rem" }}>
                  <h1 className='myCenter' style={{ color: "black", fontWeight: "bold" }}>Donor Information</h1>
                </div>

                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className='row pb-0 pb-md-2'>
                    <div className='col-md-6'>
                      <Label className='form-label label' for='firstname'>
                        First name
                      </Label>
                      <InputGroup className='input-group-merge mb-2'>
                        <InputGroupText>
                          <User size={14} />
                        </InputGroupText>
                        <Controller
                          name='firstName'
                          rules={{ required: true }}
                          control={control}
                          render={({ field }) => (
                            <Input id='firstName' placeholder='First name' invalid={errors.firstName && true} {...field} />
                          )}
                        />

                      </InputGroup>
                      {errors.firstName && <span className='text-danger'>First name is required</span>}
                    </div>
                    <div className='col-md-6'>
                      <Label className='form-label label' for='lastname'>
                        Last name
                      </Label>
                      <InputGroup className='input-group-merge mb-2'>
                        <InputGroupText>
                          <User size={14} />
                        </InputGroupText>
                        <Controller
                          name='lastName'
                          rules={{ required: true }}
                          control={control}
                          render={({ field }) => (
                            <Input id='lastName' placeholder='Last name' invalid={errors.lastName && true} {...field} />
                          )}
                        />
                        {/* <Input type='text' id='lastname' placeholder='Last name'  {...register("lastName", { required: true })} /> */}
                      </InputGroup>
                      {errors.lastName && <span className='text-danger'>Last name is required</span>}
                    </div>
                  </div>
                  <div className='row pb-0 pb-md-2'>
                    <div className='col-md-6'>
                      <Label className='form-label label' for='email'>
                        Email
                      </Label>
                      <InputGroup className='input-group-merge mb-2'>
                        <InputGroupText>
                          <Mail size={14} />
                        </InputGroupText>
                        {/* <Input type='email' id='email' placeholder='Enter your email' name="email" value={formValues.email} onChange={ChangeFormValues} /> */}
                        {/* <Input type='email' id='email' placeholder='Enter your email' {...register("email", { required: true })} /> */}
                        <Controller
                          name='email'
                          error={errors.email?.message}
                          rules={{ required: 'Email is required',
                            pattern: {
                              value: /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                              message: 'Please enter a valid Email'
                            } }}
                          control={control}
                          render={({ field }) => (
                            <Input id='email' placeholder='Enter your email' invalid={errors.email && true} {...field} />
                          )}
                        />
                      </InputGroup>
                      {errors.email && <span className='text-danger'>{errors.email?.message}</span>}
                    </div>
                    <div className='col-md-6'>
                      <Label className='form-label label' for='phone'>
                        Phone
                      </Label>
                      <InputGroup className='input-group-merge mb-2'>
                        <InputGroupText>
                          <Phone size={14} />
                        </InputGroupText>
                        <Controller
                          name='phone'
                          error={errors.phone?.message}
                          control={control}
                          render={({ field }) => (
                            <Input id='email' placeholder='(888) 888-8888' invalid={errors.phone && true} {...field} />
                          )}
                        />
                      </InputGroup>
                      {errors.phone && <span className='text-danger'>{errors.phone?.message}</span>}
                    </div>
                  </div>
                  <div className='row pb-0 pb-md-0'>
                    <div className='col-md-12'>
                      <Label className='form-label label' for='message'>
                        Please enter a private message (optional) that will be delivered to this fundraiser.
                      </Label>
                      <InputGroup className='input-group-merge mb-2'>
                        <InputGroupText style={{}}>
                          <Mail size={14} />
                        </InputGroupText>
                        {/* <Input type='textarea' id='message' rows='3' placeholder='Enter your message' name="message" value={formValues.message} onChange={ChangeFormValues} /> */}
                        {/* <Input type='textarea' id='message' rows='3' placeholder='Enter your message' {...register("message", {})} /> */}
                        <Controller
                          name='message'
                          control={control}
                          render={({ field }) => (
                            <Input  type='textarea' id='message' rows='3' placeholder='Enter your message' {...field} />
                          )}
                        />
                      </InputGroup>

                    </div>
                  </div>

                  <div className='row' style={{ paddingBottom: "2rem" }}>
                    <div className='col-md-12'>
                      <div className='form-check form-check-primary'>
                        <Controller
                          name='showAnnonymous'
                          control={control}
                          render={({ field }) => (
                            <Input  type='checkbox' id='showAnnonymous' {...field} />
                          )}
                        />
                        <Label className='form-check-label label' for='checkbox1'>
                          Make this an anonymous donation
                        </Label>
                      </div>
                    </div>
                  </div>
                  <div className='row' style={{ paddingBottom: "1rem" }}>
                    <div className='col-md-12 myFlex'>
                      {/* <a onClick={setActiveTab} className="myCenter donate_btn" href="thankyou">Continue to Payment Information</a> */}
                      <input  className="myCenter donate_btn" type="submit" value = "Continue to Payment Information" />

                    </div>
                  </div>
                </form>
              </div>
              <div className='col-md-2'></div>
            </div>
            
          </Container>)}
          {isContinue && (<Container fluid="md" className='container'>
            <div className="myFlex" style={{ paddingBottom: "3rem" }}>
              <h1 className='myCenter' style={{ color: "black", fontWeight: "bold" }}>Payments Method</h1>
            </div>
            <div className="text-center mb-4">
                <p className='mb-25 mb-1 border rounded p-1 border-danger' hidden={tipAmount > 0}>Covering platform fees helps to continuously improve our platform for donors like you and the fundraisers you are supporting. The first 15% of your support goes directly to the fundraiser.</p>
                <strong style={{ fontSize: "18px" }}>Your Total Due Today: {currFormat.to(coverFeeAmount)}</strong>
            </div> 
            {(
              <div className='row justify-content-md-center'>
                <div className='col-md-8 col-sm-12'>
                  <Elements options={options} stripe={stripePromise}>
                    <CheckoutForm formData={formValues} clientSecret={clientSecret} donation={donation} donationAmount={donationAmount} updateClientSecret={updateClientSecret} />
                  </Elements>
                </div>
              </div>
            )}
            <Row>
              <Col>
                <p className='mt-1 text-small text-center'>By continuing, you agree with the FundYouthSports <a href="https://fundyouthsports.com/terms-and-conditions/" target="_blank">terms of use</a> and <a href="https://fundyouthsports.com/privacy-policy/" target="_blank">privacy policy</a>.</p>
              </Col>
            </Row>
            <div className='row' style={{ paddingBottom: "0rem" }}>
              <div className='col-md-2 myFlex'>
                {/* <a className="myLeft donate_btn" href="thankyou">Donate Now</a> */}
              </div>
            </div>
          </Container>)}

        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default DonationForm
